import { Trans } from "react-i18next";

// The next step for someone locked out: a social login with an unknown address, or a reset that may send nothing.
export default function LoginHelp() {
  return (
    <span className="text-gray-500 text-sm text-center">
      <Trans
        i18nKey="login.stuckHelp"
        components={{ mail: <a className="font-semibold underline" href="mailto:info@dobu.app" /> }}
      />
    </span>
  );
}
